import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { Button } from '@monorepo/shared/componentsV2/Button';
import { ButtonsGroup } from '@monorepo/shared/componentsV2/ButtonsGroup';
import { TextBlock } from '@monorepo/shared/componentsV2/TextBlock';
import { Tooltip } from '@monorepo/shared/componentsV2/Tooltip';
import { useFeatureFlags } from 'mapistry-shared/api';
import React from 'react';
import styled from 'styled-components';

export const LEGACY_LOG_FORMULAS_DISABLED_EXPLANATION =
  'Log Formulas Are Being Phased Out. Please create new formulas using Workflows instead. If you need to make a change to an existing formula, reach out to customer support.';

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 1rem;
  text-align: center;
`;

export function EditLogFormulasEmptyState({
  openModal,
}: {
  openModal: () => void;
}) {
  const { areLegacyLogFormulasEnabled } = useFeatureFlags();

  return (
    <StyledDiv>
      <TextBlock
        primaryText="You do not have any formula fields yet!"
        secondaryText="Formula fields allow you to perform basic operations between two or more Log fields."
      />
      <ButtonsGroup>
        <Tooltip
          title={
            areLegacyLogFormulasEnabled
              ? ''
              : LEGACY_LOG_FORMULAS_DISABLED_EXPLANATION
          }
        >
          <span>
            <Button
              color="primary"
              onClick={() => openModal()}
              disabled={!areLegacyLogFormulasEnabled}
              focusableWhenDisabled={!areLegacyLogFormulasEnabled}
            >
              <AddCircleOutlineIcon />
              Add a formula
            </Button>
          </span>
        </Tooltip>
      </ButtonsGroup>
    </StyledDiv>
  );
}
